export function isValidAttachment(type, allowPhotos, allowVideos) {
    return (allowPhotos && type.match(/^image/)) || (allowVideos && type.match(/^video/));
}
